module.exports = __webpack_public_path__ + "img/soundcloud.d7feba16.png";